/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getYahooCampaigns} from '../api'

 export const useQueryGetYahooCampaigns = createReactQueryHook('getYahooCampaigns', getYahooCampaigns)
